import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { FireKpiNotifier } from './fire-kpi-notifier';
import { FireKpiState } from './fire-kpi-state';

/**
 * FireKpiProvider — portador del KPI de incendios del header.
 * Sin `providedIn: 'root'` a propósito: se lista en `VIEWER_PROVIDERS` para
 * que al cerrar sesión el notifier se destruya y el conteo no arrastre el
 * ámbito de la sesión anterior. Ver `viewer-providers.ts`.
 */
@Injectable()
export class FireKpiProvider extends BaseProvider<FireKpiNotifier, FireKpiState> {
  constructor() {
    super(FireKpiNotifier);
  }
}
